<template>
  <el-table-column
    prop="gross_price"
    sortable="custom"
    label="Bruttó ár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.gross_price | currency(scope.row.currency_code) }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'gross_price',
  };
</script>
